module.exports = {"211021100":"首山镇","211021101":"刘二堡镇","211021103":"小北河镇","211021104":"黄泥洼镇","211021106":"唐马寨镇","211021107":"穆家镇","211021108":"柳壕镇","211021110":"河栏镇","211021111":"隆昌镇","211021112":"八会镇","211021113":"寒岭镇","211021114":"兴隆镇","211021201":"下达河乡","211021202":"吉洞峪满族乡","211021206":"甜水满族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/211021.json
// module id = 664
// module chunks = 0